import BindMobile from "./BindMobile"
import store from '@/store/store.js'
import router from '@/router/router.js'

const obj = {}

obj.install = function (Vue) {
    //1.创建组件构造器
    const Construct = Vue.extend(BindMobile)

    //2.用new 的方式用组件构造器创建出来组件对象
    const bindMobile = new Construct({ store, router })

    //3.将组件对象手动挂载到某一个元素上
    bindMobile.$mount(document.createElement('div'))

    //4.bindMobile.$el对应的就是div
    document.body.appendChild(bindMobile.$el)

    //5.在原型中加入BindMobileDialog
    Vue.prototype.$BindMobileDialog = bindMobile

}

export default obj
